var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"box-img",attrs:{"src":_vm.msg.imgURL,"alt":""},on:{"click":function($event){return _vm.$emit('remix', { msg: _vm.msg })}}})}
var staticRenderFns = []

export { render, staticRenderFns }